var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasErrors
    ? _c(
        "div",
        { staticClass: "visit-error-notifications" },
        [
          _vm._l(_vm.visibleErrors, function (error) {
            return _c("VisitErrorNotification", {
              key: error.type,
              attrs: { error: error, show: _vm.shouldShowErrors },
            })
          }),
          _vm.skillsError && _vm.skillsError.show
            ? _c("div", { staticClass: "mb-2" }, [
                _c("div", { staticClass: "text-red-600 text-sm mb-1" }, [
                  _vm._v(_vm._s(_vm.skillsError.message)),
                ]),
                _c(
                  "div",
                  { staticClass: "flex justify-left py-2 flex-wrap gap-1" },
                  _vm._l(
                    _vm.skillsError.additionalData.missingSkills,
                    function (skill) {
                      return _c(
                        "span",
                        {
                          key: skill.id,
                          staticClass:
                            "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 transition-[color,box-shadow] overflow-hidden border-transparent bg-red-100 text-red-800 hover:bg-red-200",
                        },
                        [_vm._v(" " + _vm._s(skill.name) + " ")]
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _vm.softSkillsError && _vm.softSkillsError.show
            ? _c("div", { staticClass: "mb-2" }, [
                _c("div", { staticClass: "text-red-600 text-sm mb-1" }, [
                  _vm._v(_vm._s(_vm.softSkillsError.message)),
                ]),
                _c(
                  "div",
                  { staticClass: "flex justify-left py-2 flex-wrap gap-1" },
                  _vm._l(
                    _vm.softSkillsError.additionalData.missingSoftSkills,
                    function (skill) {
                      return _c(
                        "span",
                        {
                          key: skill.id,
                          staticClass:
                            "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 transition-[color,box-shadow] overflow-hidden border-transparent bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
                        },
                        [_vm._v(" " + _vm._s(skill.name) + " ")]
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _vm.travelError &&
          _vm.travelError.show &&
          _vm.travelError.additionalData.transportMethods
            ? _c("div", { staticClass: "mb-2" }, [
                _c("div", { staticClass: "flex justify-left py-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center gap-6 bg-white border border-gray-200 rounded-lg p-3 shadow-sm",
                    },
                    _vm._l(
                      _vm.travelError.additionalData.transportMethods,
                      function (transport) {
                        return _c(
                          "div",
                          {
                            key: transport.type,
                            staticClass: "flex flex-col items-center gap-1",
                          },
                          [
                            _c(_vm.getTransportIcon(transport.type), {
                              tag: "component",
                              staticClass: "w-6 h-6 text-black-600",
                            }),
                            _c(
                              "span",
                              { staticClass: "text-sm text-gray-700" },
                              [_vm._v(_vm._s(transport.time))]
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }